export const CaseStudies = () => {
  const cases = [
    {
      title: 'Downtown Retail/Residential',
      location: 'City Center',
      details: {
        units: '24 apartments + 4 retail',
        condition: 'Partially vacant retail',
        timeline: '42 days to close',
        challenge: 'Two vacant retail spaces, aging building'
      },
      story: 'The owner struggled to lease ground-floor retail spaces after two long-term tenants left. The building also needed facade work and system upgrades. We provided an offer that accounted for the vacancy and capital needs.',
      outcome: 'Seller received fair value and avoided ongoing carrying costs and capital expenditures.'
    },
    {
      title: 'Main Street Mixed-Use',
      location: 'Suburban Downtown',
      details: {
        units: '12 apartments + 3 offices',
        condition: 'Good condition',
        timeline: '38 days to close',
        challenge: 'Partnership dissolution needed'
      },
      story: 'Two partners who had owned this property for 12 years wanted to pursue different investment strategies. We structured a purchase that provided a clean exit for both parties.',
      outcome: 'Both partners received their proceeds and were able to pursue individual goals.'
    },
    {
      title: 'Restaurant/Residential Building',
      location: 'Urban Neighborhood',
      details: {
        units: '16 apartments + restaurant',
        condition: 'Needs updating',
        timeline: '45 days to close',
        challenge: 'Restaurant tenant issues, deferred maintenance'
      },
      story: 'The restaurant tenant was struggling, and the residential units needed updating. The owner wanted to exit before dealing with a potential restaurant closure and renovation costs.',
      outcome: 'Seller avoided complex tenant and renovation issues while receiving competitive pricing.'
    }
  ];

  return (
    <section className="py-20 bg-gradient-to-br from-gray-50 to-gray-100">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold mb-6 text-gray-900">
            Recent Mixed-Use Acquisitions
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto leading-relaxed">
            Real examples of mixed-use properties we've purchased and the solutions we provided to sellers.
          </p>
        </div>

        <div className="space-y-8">
          {cases.map((caseStudy, index) => (
            <div key={index} className="bg-white rounded-xl shadow-lg overflow-hidden">
              <div className="grid md:grid-cols-3 gap-8 p-8">
                <div className="md:col-span-1">
                  <div className="bg-gradient-to-br from-teal-500 to-cyan-600 text-white rounded-xl p-6">
                    <h3 className="text-2xl font-bold mb-2">{caseStudy.title}</h3>
                    <p className="text-white/90 mb-6">{caseStudy.location}</p>
                    <div className="space-y-3">
                      <div className="flex items-center">
                        <i className="ri-building-line mr-3 text-xl"></i>
                        <span className="text-sm">{caseStudy.details.units}</span>
                      </div>
                      <div className="flex items-center">
                        <i className="ri-tools-line mr-3 text-xl"></i>
                        <span className="text-sm">{caseStudy.details.condition}</span>
                      </div>
                      <div className="flex items-center">
                        <i className="ri-time-line mr-3 text-xl"></i>
                        <span className="text-sm">{caseStudy.details.timeline}</span>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="md:col-span-2">
                  <div className="mb-6">
                    <h4 className="text-lg font-semibold mb-2 text-gray-900">The Challenge:</h4>
                    <p className="text-gray-600 leading-relaxed">{caseStudy.details.challenge}</p>
                  </div>
                  <div className="mb-6">
                    <h4 className="text-lg font-semibold mb-2 text-gray-900">The Story:</h4>
                    <p className="text-gray-700 leading-relaxed">{caseStudy.story}</p>
                  </div>
                  <div className="bg-teal-50 rounded-lg p-6">
                    <h4 className="text-lg font-semibold mb-2 text-teal-900">The Outcome:</h4>
                    <p className="text-teal-800 leading-relaxed">{caseStudy.outcome}</p>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>

        <div className="mt-16 text-center">
          <p className="text-xl text-gray-600 mb-8">
            Every mixed-use property and seller situation is unique. We'd like to learn about yours.
          </p>
          <a 
            href="#get-offer" 
            className="whitespace-nowrap inline-block bg-teal-500 text-white px-8 py-4 rounded-lg text-lg font-semibold hover:bg-teal-600 transition-all duration-300 shadow-lg hover:shadow-xl cursor-pointer"
          >
            Share Your Property Details
          </a>
        </div>
      </div>
    </section>
  );
};